<template>
      <v-col>
        <v-card flat>
         <v-data-table
            :key="componentKey"
            :headers="headers"
            :items="tableItems"
            class="elevation-1"
            :loading="dueByRateCategoriesLoadStatus===1"
            disable-pagination
            hide-default-footer
            must-sort
            dense
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Należności wg grupy cennika</v-toolbar-title>
                
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select label="Rok" v-model="selectedYear"  class="choose_year" :items="calendarYears" hide-details ></v-select>
               
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select label="Miesiąc" v-model="selectedMonth"  class="choose_month" :items="lookups.months" hide-details ></v-select>

                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select label="Grupa cennika" v-model="selectedRateCategory"  class="choose_rate" :items="lookups.rate_categories" clearable hide-details ></v-select>
                <v-spacer></v-spacer>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              size="28"
                              class="mr-4"
                              :disabled="tableItems.length==0"
                              @click="downloadXlsFile"
                            >
                              mdi-file-excel
                            </v-icon>
                          </template>
                          <span>Pobierz jako Excel</span>
                        </v-tooltip>

                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              size="28"
                              class="mr-4"
                              :disabled="tableItems.length==0"
                              @click="printFile"
                            >
                              mdi-printer
                            </v-icon>
                          </template>
                          <span>Drukuj</span>
                        </v-tooltip>

              </v-toolbar>
            </template>

             <template v-slot:item.last_rate_category="{ item }">
                {{ _.find(lookups.rate_categories,{'value':item.last_rate_category}).text }}
            </template>
              <template v-slot:item.debt_stay="{ item }">
                {{ $n(item.debt_stay, 'currency', 'pl-PL') }}
            </template>
             <template v-slot:item.debt_meal="{ item }">
                {{ $n(item.debt_meal, 'currency', 'pl-PL') }}
            </template>
             <template v-slot:item.due_stay="{ item }">
                {{ $n(item.due_stay, 'currency', 'pl-PL') }}
            </template>
             <template v-slot:item.due_meal="{ item }">
                {{ $n(item.due_meal, 'currency', 'pl-PL') }}
            </template>
            <!-- <template v-if="tableItems.length>1" slot="body.append">
                <tr class="v-data-table__selected font-weight-medium subheading">
                        <td></td><td></td><td></td><td></td><td></td>
                        <td>Suma</td>
                        <td>{{ sumField('hours')}}</td>
                        <td></td>
                        <td>{{ sumField('hoursAmount')}}</td>
                </tr>
            </template> -->
          </v-data-table> 
        </v-card>
      
      </v-col>
      

</template>

<script>
  import Vue from 'vue'
  import XLSX from "xlsx"
  import jsPDF from 'jspdf'
  import logusLogo from '../../plugins/jspdf_resources'
  import 'jspdf-autotable'

  export default {
    data: () => ({
      componentKey:0,
      dialog: false,
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp'},
        { text: 'Grupa cennikowa', value: 'last_rate_category'},
         { text: 'Zaległości Pobyt', value: 'debt_stay'},
        { text: 'Zaległości Żywienie', value: 'debt_meal'},
        { text: 'Należność Pobyt', value: 'due_stay'},
        { text: 'Należność Żywienie', value: 'due_meal'},
      ],
      
    }),
    watch: {
     
    },
    computed: {
      calendarYears(){
        var calYears = [];
        this.lookups.years.forEach(year => {
          if(!Vue._.find(calYears,{value:year.year_from}))calYears.push({value:year.year_from,text:year.year_from.toString()});
          if(!Vue._.find(calYears,{value:year.year_to}))calYears.push({value:year.year_to,text:year.year_to.toString()});
        });
        return calYears;
      },
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      options:{
        get () {  
          return this.$store.getters.getDueByRateCategoriesOptions;
        },
        set (value) {
          this.$store.dispatch( 'setDueByRateCategoriesOptions', {options:value} )
        }
      },
      selectedYear:{
        get () {
          return this.$store.getters.getDueByRateCategoriesOptions.selectedYear;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedYear = value;
          this.options = currentOptions;
        }
      },

      selectedMonth:{
        get () {
          return this.$store.getters.getDueByRateCategoriesOptions.selectedMonth;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedMonth = value;
          this.options = currentOptions;
        }
      },
      selectedRateCategory:{
        get () {
          return this.$store.getters.getDueByRateCategoriesOptions.selectedRateCategory;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedRateCategory = value;
          this.options = currentOptions;
        }
      },
     
      tableItems(){
        return this.$store.getters.getDueByRateCategories;
      },
      dueByRateCategoriesLoadStatus(){
        return this.$store.getters.getDueByRateCategoriesLoadStatus;
      },
      
    },
    mounted(){
      if(this.lookups.years.length>0){
        this.loadDueByRateCategories();
      }else{
        this.$store.dispatch( 'loadLookups' );
        setTimeout(() => {
          this.loadDueByRateCategories();
        }, 2000)
      }
    },
    methods: {
      sumField(key) {
        // sum data in give key (property)
        return this.tableItems.reduce((a, b) => a + ((b && b[key])?b[key]:0 || 0), 0)
      },
      loadDueByRateCategories(){
        var currentOptions = {...this.$store.getters.getDueByRateCategoriesOptions};
        var date = new Date(); 
        //currentOptions.selectedDay = date.toISOString().substr(0,10);
        currentOptions.selectedYear = parseInt(date.toISOString().substr(0,4));
        currentOptions.selectedMonth = parseInt(date.toISOString().substr(6,2));
        this.options = currentOptions;
      },
      downloadXlsFile(){
        //przygotowanie danych
        var items = []
        this.tableItems.forEach(item => {
          items.push({
            last_rate_category:_.find(this.lookups.rate_categories,{'value':item.last_rate_category}).text,
            debt_stay:item.debt_stay,
            debt_meal:item.debt_meal,
            due_stay:item.due_stay, 
            due_meal:item.due_meal
          })
        });

        var wb = XLSX.utils.book_new()
        var ws_name = "Zestawienie";
        var ws = XLSX.utils.aoa_to_sheet([["Grupa cennikowa","Zaległości Pobyt","Zaległości Żywienie","Należność Pobyt","Należność Żywienie"]]);
        XLSX.utils.sheet_add_json(ws,items,{header:["last_rate_category","debt_stay","debt_meal","due_stay","due_meal"], skipHeader:true, origin:1})
        
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
      
        var rightNow = new Date();
        rightNow.setMinutes(rightNow.getMinutes() - rightNow.getTimezoneOffset());
        var filename = 'Zestawienie_' + rightNow.toISOString().replace(/-/g,'').replace(/:/g,'').replace('T','_').slice(0,15) +'.xlsx';
        XLSX.writeFile(wb, filename, {})
      },
      generatePDF(){
        var items = []
        var page = 1;
        var lp = 1;
        this.tableItems.sort((a,b)=>(a.last_rate_category>b.last_rate_category)?1:(b.last_rate_category>a.last_rate_category)?-1:0).forEach(item => {
          items.push([
            lp++,
            _.find(this.lookups.rate_categories,{'value':item.last_rate_category}).text,
            this.$n(item.debt_stay, 'currency', 'pl-PL'),
            this.$n(item.debt_meal, 'currency', 'pl-PL'),
            this.$n(item.due_stay, 'currency', 'pl-PL'),
            this.$n(item.due_meal, 'currency', 'pl-PL')
            ]);
        });

        var doc = new jsPDF({
          //orientation: 'landscape',
          unit: 'mm',
          format: 'a4',
        })
        var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
        var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

        doc.setFont("Roboto-Medium", "bold"); // set font
        doc.setFontSize(14);
        doc.addImage(logusLogo, 'PNG', 5, 5, 22.5, 20);
        doc.text('Należności wg grupy', pageWidth-5, 12, {align:'right',baseline:'bottom'});
        doc.text(_.find(this.lookups.months,{'value':this.selectedMonth}).text + ' ' + this.selectedYear.toString() + ', ' + (this.selectedRateCategory?_.find(this.lookups.rate_categories,{'value':this.selectedRateCategory}).text:''), pageWidth-5, 20, {align:'right',baseline:'bottom'});
        doc.setFont("Roboto-Regular", "normal"); // set font
        doc.setFontSize(10);
        doc.autoTable({
          didDrawPage: (data) => {
            //doc.text(page.toString(), 5, pageHeight-5);
            doc.text(page.toString(), 5, pageHeight-5, {align:'center',baseline:'bottom'});
            doc.text(this.user.name + ' ' + this.user.surname + ' / '+ new Date().toLocaleString(), pageWidth-5, pageHeight-5, {align:'right'});
            page++;
          },
          theme:'grid',
          styles:{font:'Roboto-Regular', fontSize:9 },
          headStyles: { fillColor: [210, 210, 210],textColor:20 },
          footStyles: { fillColor: [210, 210, 210],textColor:20 },
          startY: 30,
          showFoot:'lastPage',
          margin: {top:5,bottom:10,left:5,right:5},
          //columnStyles: { 3: {font:'Roboto-Medium', halign: 'right' },4: {font:'Roboto-Medium', halign: 'right' }, 5: {font:'Roboto-Medium', halign: 'right' },6: {font:'Roboto-Medium', halign: 'right' } },
          head: [_.map(this.headers,'text')],
          body: items,
          foot: [
            [
                 { content: 'Suma', colSpan: 2, styles: {font:'Roboto-Medium',fontStyle:'bold', halign: 'right' } },
                 { content: this.$n(this.sumField('debt_stay'), 'currency', 'pl-PL'),styles: {font:'Roboto-Medium',fontStyle:'bold',halign: 'left' }},
                 //{ content: '',styles: {font:'Roboto-Medium',fontStyle:'bold',halign: 'left' }},
                 { content: this.$n(this.sumField('debt_meal'), 'currency', 'pl-PL'),styles: {font:'Roboto-Medium',fontStyle:'bold',halign: 'left' }},
                 { content: this.$n(this.sumField('due_stay'), 'currency', 'pl-PL'),styles: {font:'Roboto-Medium',fontStyle:'bold',halign: 'left' }},
                 { content: this.$n(this.sumField('due_meal'), 'currency', 'pl-PL'),styles: {font:'Roboto-Medium',fontStyle:'bold',halign: 'left' }},
            ],
          ],
        })
        
        return doc;
      },
      printFile(){
        var doc = this.generatePDF();
        doc.autoPrint();
        doc.output('dataurlnewwindow');
        doc.close();
      },
    },
  }
</script>


<style scoped>
.choose_year{
      max-width: 100px;
}
.choose_month{
      max-width: 150px;
}
.choose_rate{
      max-width: 200px;
}
</style>